import React, { PropsWithChildren } from 'react'
import { Provider } from 'outstated'
import { ThemeProvider } from 'emotion-theming'
import { Theme, navMenuStore } from './design-system'
import { themeFonts, themeColor } from './twt-core/theme'
import { fontFamilies2019 } from './twt-2019/theme';
import { Global, css } from '@emotion/core';
import { extname } from 'path'

const PageContext = ({ children }: PropsWithChildren<{}>) => {
  return (
    <>
      {fontFamilies2019.map(({ name, decls }) =>
        decls.map(({ weight, src, style = 'normal' }) => (
          <Global
            key={src.join(',')}
            styles={css`
            @font-face {
              font-family: '${name}';
              src: ${src
                .map(u => `url(${u}) format('${extname(u).substr(1)}')`)
                .join(', ')};
              font-weight: ${weight};
              font-style: ${style};
            }
          `}
          />
        )),
      )}
    <ThemeProvider theme={new Theme(themeColor, themeFonts)}>
      <Provider stores={[navMenuStore]}>{children}</Provider>
    </ThemeProvider>
    </>
  )
}

export default PageContext
